import React from 'react';
import PropTypes from 'prop-types';
import { FONT, COLOURS, SHADOW } from '../../constants/theme';

/**
 * PixelWindow — a windowed container styled after retro OS dialog boxes.
 *
 * Renders a coloured title bar with two decorative "close" squares,
 * and a padded body area for arbitrary children.
 *
 * @param {object}    props
 * @param {string}    props.title    - Title bar text.
 * @param {React.ReactNode} props.children - Window body content.
 */
function PixelWindow({ title, children }) {
  return (
    <div
      style={{
        background: COLOURS.cream,
        border:     `3px solid ${COLOURS.borderAmber}`,
        boxShadow:  SHADOW.window,
        margin:     '10px 0',
        fontFamily: FONT,
      }}
    >
      {/* Title bar */}
      <div
        style={{
          background:  COLOURS.primaryLight,
          padding:     '5px 8px',
          display:     'flex',
          justifyContent: 'space-between',
          alignItems:  'center',
        }}
      >
        <span style={{ fontSize: 7, color: COLOURS.textInverted }}>{title}</span>

        {/* Decorative close squares — not interactive */}
        <div style={{ display: 'flex', gap: 4 }} aria-hidden="true">
          {[0, 1].map((i) => (
            <div
              key={i}
              style={{
                width:  8,
                height: 8,
                background: COLOURS.textInverted,
                border: `2px solid ${COLOURS.primaryDark}`,
              }}
            />
          ))}
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: '12px 14px' }}>{children}</div>
    </div>
  );
}

PixelWindow.propTypes = {
  title:    PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default PixelWindow;
